(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["ahvte-journal"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('ahvte-journal')) customElements.define('ahvte-journal', class extends HTMLElement {
  connectedCallback() {
    if (this.cleanup) return;
    const track = this.querySelector('.ahj__track');
    if (!track) return;
    const abort = new AbortController(), signal = abort.signal;
    const cards = [...track.children], controls = this.querySelector('.ahj__carousel-controls'), counter = this.querySelector('.ahj__counter'), play = this.querySelector('[data-play]');
    const motion = matchMedia('(prefers-reduced-motion: reduce)');
    let timer, playing = this.dataset.autoplay === 'true' && !motion.matches, inView = true;
    const countVisible = () => Math.max(1, Math.floor((track.clientWidth + 24) / (cards[0].getBoundingClientRect().width + parseFloat(getComputedStyle(track).gap))));
    const position = () => Math.round(Math.abs(track.scrollLeft) / (cards[0].getBoundingClientRect().width + parseFloat(getComputedStyle(track).gap)));
    const update = () => { const overflow = track.scrollWidth > track.clientWidth + 2; controls.hidden = !overflow; counter.textContent = `${Math.min(position() + 1, cards.length)}–${Math.min(position() + countVisible(), cards.length)} / ${cards.length}`; play.textContent = playing ? play.dataset.pauseLabel : play.dataset.playLabel; play.disabled = motion.matches; counter.setAttribute('aria-live', playing ? 'off' : 'polite'); };
    const go = direction => { const max = Math.max(0, cards.length - countVisible()); const current = position(); const index = direction > 0 ? (current >= max ? 0 : Math.min(max, current + countVisible())) : (current <= 0 ? max : Math.max(0, current - countVisible())); const rtl = getComputedStyle(track).direction === 'rtl'; track.scrollTo({left:(rtl ? -1 : 1) * index * (cards[0].getBoundingClientRect().width + parseFloat(getComputedStyle(track).gap)), behavior:motion.matches ? 'auto' : 'smooth'}); };
    const schedule = () => { clearInterval(timer); if (!this.isConnected || signal.aborted) return; if (track.scrollWidth > track.clientWidth + 2 && playing && inView && !document.hidden && !motion.matches && !this.matches(':hover') && !this.contains(document.activeElement)) timer = setInterval(() => go(1), 6500); update(); };
    const stop = () => { playing = false; schedule(); };
    this.querySelector('[data-prev]').addEventListener('click', () => { stop(); go(-1); }, {signal});
    this.querySelector('[data-next]').addEventListener('click', () => { stop(); go(1); }, {signal});
    play.addEventListener('click', () => { playing = !playing; schedule(); }, {signal});
    track.addEventListener('pointerdown', stop, {signal});
    track.addEventListener('keydown', stop, {signal});
    track.addEventListener('scroll', update, {signal, passive:true});
    this.addEventListener('mouseenter', schedule, {signal}); this.addEventListener('mouseleave', schedule, {signal});
    this.addEventListener('focusin', () => { clearInterval(timer); }, {signal}); this.addEventListener('focusout', () => setTimeout(schedule,0), {signal});
    document.addEventListener('visibilitychange', schedule, {signal});
    motion.addEventListener('change', () => { if (motion.matches) playing = false; schedule(); }, {signal});
    const resize = new ResizeObserver(schedule); resize.observe(track);
    const intersection = new IntersectionObserver(entries => { inView = entries[0].isIntersecting; schedule(); }); intersection.observe(this);
    this.cleanup = () => { abort.abort(); clearInterval(timer); resize.disconnect(); intersection.disconnect(); };
    schedule();
  }
  disconnectedCallback() { this.cleanup?.(); this.cleanup = null; }
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ahvte-product-spotlight"] && !Shopify.designMode) return;
  try {
    
(() => {
  if (customElements.get('ahvte-product-spotlight')) return;
  class Spotlight extends HTMLElement {
    connectedCallback() {
      if (this.started) return;
      this.started = true;
      this.abort = new AbortController();
      this.rows = []; this.pool = []; this.deck = []; this.paused = false; this.hovered = false; this.focused = false; this.visible = true;
      this.status = this.querySelector('.spot-status'); this.button = this.querySelector('.spot-toggle');
      this.motion = matchMedia('(prefers-reduced-motion: reduce)');
      this.button.addEventListener('click', () => { this.paused = !this.paused; this.updateMode(); }, {signal:this.abort.signal});
      this.addEventListener('mouseenter', () => {this.hovered = true;}, {signal:this.abort.signal});
      this.addEventListener('mouseleave', () => {this.hovered = false;}, {signal:this.abort.signal});
      this.addEventListener('focusin', () => {this.focused = true; this.updateMode();}, {signal:this.abort.signal});
      this.addEventListener('focusout', () => {queueMicrotask(() => {this.focused = this.contains(document.activeElement); this.updateMode();});}, {signal:this.abort.signal});
      this.motion.addEventListener('change', () => this.updateMode(), {signal:this.abort.signal});
      this.observer = new IntersectionObserver(entries => {this.visible = entries[0].isIntersecting;}, {rootMargin:'100px'}); this.observer.observe(this);
      this.resize = new ResizeObserver(() => {if(this.pool.length && !this.focused) this.build();}); this.resize.observe(this);
      this.load();
    }
    disconnectedCallback() {this.abort?.abort(); this.observer?.disconnect(); this.resize?.disconnect(); cancelAnimationFrame(this.frame); this.started = false;}
    shuffle(items) {const result = items.slice(); for(let i=result.length-1;i>0;i--){const j=Math.floor(Math.random()*(i+1)); [result[i],result[j]]=[result[j],result[i]];} return result;}
    async load() {
      let initial; try {initial=JSON.parse(this.querySelector('[data-spot-feed]').textContent);} catch(error) {this.status.textContent=this.status.dataset.error; return;}
      const all = new Map();
      const collect = feed => {for(const product of feed.products) if(product.image && product.url) all.set(String(product.id),product);};
      collect(initial); this.status.textContent = this.status.dataset.loading;
      let failed = false;
      try {
        for(let page=1;page<=Math.min(initial.pages,100);page++) {
          if(page===initial.page) continue;
          const url = new URL(location.href); url.searchParams.set('section_id',this.dataset.section); url.searchParams.set(initial.param,page);
          const response = await fetch(url, {signal:this.abort.signal});
          if(!response.ok) throw new Error('Catalog request failed');
          const html = new DOMParser().parseFromString(await response.text(),'text/html');
          const node = html.querySelector('[data-spot-feed]'); if(!node) throw new Error('Missing catalog data');
          const feed = JSON.parse(node.textContent); if(feed.page!==page) throw new Error('Pagination did not advance'); collect(feed);
        }
      } catch(error) {if(error.name==='AbortError') return; failed=true;}
      if(!this.isConnected) return;
      this.pool=Array.from(all.values()); this.deck=this.shuffle(this.pool);
      this.status.textContent = failed || initial.total>25000 ? this.status.dataset.error : this.pool.length ? '' : this.status.dataset.empty;
      if(!this.pool.length) return;
      this.build(); this.button.hidden=false; this.updateMode(); this.last=performance.now(); this.frame=requestAnimationFrame(time=>this.tick(time));
    }
    take() {
      if(!this.deck.length) this.deck=this.shuffle(this.pool);
      const visible=new Set(Array.from(this.querySelectorAll('.spot-rows .spot-card')).map(card=>card.dataset.id));
      let index=this.deck.findIndex(product=>!visible.has(String(product.id))); if(index<0) index=0;
      return this.deck.splice(index,1)[0];
    }
    card() {
      const p=this.take(); const a=document.createElement('a'); a.className='spot-card'; a.dataset.id=String(p.id); a.href=p.url; a.title=p.title;
      const image=document.createElement('img'); image.src=p.image; image.alt=p.title; image.width=480; image.height=480; image.loading='eager'; image.decoding='async';
      image.addEventListener('error',()=>{image.remove(); a.textContent=p.title; a.style.padding='16px';},{once:true}); a.append(image); return a;
    }
    build() {
      if(this.focused) return;
      const container=this.querySelector('.spot-rows'); container.replaceChildren(); this.rows=[];
      const styles=getComputedStyle(this); this.step=parseFloat(styles.getPropertyValue('--spot-size'))+parseFloat(styles.getPropertyValue('--spot-gap'));
      const count=Math.min(20,Math.ceil(this.clientWidth/this.step)+3);
      for(let i=0;i<3;i++) {
        const track=document.createElement('div'); track.className='spot-row'; container.append(track);
        for(let n=0;n<count;n++) track.append(this.card());
        const x=i%2 ? -this.step : 0; track.style.transform=`translate3d(${x}px,0,0)`; this.rows.push({track,x,direction:i%2?1:-1});
      }
      this.setAttribute('data-ready',''); this.updateMode();
    }
    updateMode() {
      const still=this.paused || this.motion.matches; this.toggleAttribute('data-static',still || this.focused);
      this.button.setAttribute('aria-pressed',String(still)); this.button.textContent=still?this.button.dataset.play:this.button.dataset.pause;
      if(this.motion.matches){this.button.hidden=true;} else this.button.hidden=!this.pool.length;
    }
    tick(time) {
      const elapsed=Math.min(time-this.last,50)/1000; this.last=time;
      if(!document.hidden && this.visible && !this.paused && !this.motion.matches && !this.hovered && !this.focused) {
        for(const row of this.rows) {
          row.x+=row.direction*Number(this.dataset.speed)*elapsed;
          if(row.direction<0 && row.x<=-this.step){row.track.firstElementChild.remove(); row.track.append(this.card()); row.x+=this.step;}
          if(row.direction>0 && row.x>=0){row.track.lastElementChild.remove(); row.track.prepend(this.card()); row.x-=this.step;}
          row.track.style.transform=`translate3d(${row.x}px,0,0)`;
        }
      }
      this.frame=requestAnimationFrame(next=>this.tick(next));
    }
  }
  customElements.define('ahvte-product-spotlight',Spotlight);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ahvte-viral-loved"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('ahvte-loved')) {
  customElements.define('ahvte-loved', class extends HTMLElement {
    connectedCallback() {
      if (this.abort) return;
      this.abort = new AbortController();
      const options = { signal: this.abort.signal };
      this.setAttribute('data-ready', '');
      this.querySelector('[data-al-tabs]').hidden = false;
      this.tabs = [...this.querySelectorAll('[data-al-tab]')];
      this.panels = [...this.querySelectorAll('[data-al-panel]')];
      this.panels.forEach((panel, i) => { panel.setAttribute('role', 'tabpanel'); panel.setAttribute('aria-labelledby', this.tabs[i].id); });
      this.tabs.forEach((tab, index) => {
        tab.addEventListener('click', () => this.activate(index), options);
        tab.addEventListener('keydown', event => {
          const rtl = getComputedStyle(this).direction === 'rtl';
          let next;
          if (event.key === 'Home') next = 0;
          if (event.key === 'End') next = this.tabs.length - 1;
          if (event.key === 'ArrowRight') next = (index + (rtl ? -1 : 1) + this.tabs.length) % this.tabs.length;
          if (event.key === 'ArrowLeft') next = (index + (rtl ? 1 : -1) + this.tabs.length) % this.tabs.length;
          if (next === undefined) return;
          event.preventDefault(); this.activate(next); this.tabs[next].focus();
        }, options);
      });
      this.panels.forEach(panel => {
        const track = panel.querySelector('[data-al-track]');
        panel.querySelectorAll('[data-al-step]').forEach(button => button.addEventListener('click', () => {
          const rtl = getComputedStyle(track).direction === 'rtl';
          track.scrollBy({left: Number(button.dataset.alStep) * track.clientWidth * (rtl ? -1 : 1), behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth'});
        }, options));
        track.addEventListener('scroll', () => this.schedule(), { ...options, passive:true });
        track.addEventListener('keydown', event => {
          if (event.target !== track || !['Home','End'].includes(event.key)) return;
          event.preventDefault();
          track.scrollTo({left:event.key === 'Home' ? 0 : track.scrollWidth * (getComputedStyle(track).direction === 'rtl' ? -1 : 1),behavior:'instant'});
        }, options);
      });
      this.resize = new ResizeObserver(() => this.schedule()); this.resize.observe(this);
      this.activate(Math.max(0, this.tabs.findIndex(tab => tab.getAttribute('aria-selected') === 'true')));
    }
    disconnectedCallback() { this.abort?.abort(); this.abort=null; this.resize?.disconnect(); cancelAnimationFrame(this.frame); }
    activate(index) {
      this.tabs.forEach((tab,i) => { tab.setAttribute('aria-selected',String(i === index)); tab.tabIndex = i === index ? 0 : -1; });
      this.panels.forEach((panel,i) => { panel.hidden=i !== index; });
      this.schedule();
    }
    schedule() { cancelAnimationFrame(this.frame); this.frame=requestAnimationFrame(() => this.update()); }
    update() {
      this.panels.filter(panel => !panel.hidden).forEach(panel => {
        const track=panel.querySelector('[data-al-track]');
        const max=Math.max(0,track.scrollWidth-track.clientWidth);
        const position=Math.min(max,Math.max(0,Math.abs(track.scrollLeft)));
        const progress=panel.querySelector('[data-al-progress]');
        const ratio=Math.min(1,track.clientWidth / Math.max(1,track.scrollWidth));
        const rtl=getComputedStyle(track).direction === 'rtl';
        progress.style.setProperty('--al-thumb',`${ratio*100}%`);
        progress.style.setProperty('--al-offset',`${(rtl ? -1 : 1) * (max ? position/max : 0) * progress.clientWidth*(1-ratio)}px`);
        panel.querySelector('[data-al-step="-1"]').disabled=position < 2;
        panel.querySelector('[data-al-step="1"]').disabled=position >= max-2;
        panel.querySelectorAll('[data-al-step]').forEach(button => {button.hidden=max < 2;});
        const image=track.querySelector('.al-image-link');
        if(image) panel.style.setProperty('--al-arrow-y',`${image.offsetHeight/2 + 4}px`);
      });
    }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["collage"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('ahvte-random-reviews')) {
  customElements.define('ahvte-random-reviews', class extends HTMLElement {
    connectedCallback() {
      queueMicrotask(() => { if (this.isConnected && !this.cleanup) this.init(); });
    }
    disconnectedCallback() { this.cleanup?.(); this.cleanup = null; }
    init() {
      const root = this;
      const slides = [...root.querySelectorAll('[data-review-slide]')];
      const dots = [...root.querySelectorAll('[data-review-dot]')];
      const track = root.querySelector('[data-review-track]');
      if (!track || !slides.length) return;
      const viewport = root.querySelector('.ahvte-random-reviews__viewport');
      const toggle = root.querySelector('[data-review-toggle]');
      const motion = matchMedia('(prefers-reduced-motion: reduce)');
      const hoverMedia = matchMedia('(hover: hover) and (pointer: fine)');
      const controller = new AbortController();
      const on = (node, event, handler) => node?.addEventListener(event, handler, {signal: controller.signal});
      const interval = Math.max(4000, Number(root.dataset.interval) || 7000);
      let position = Math.floor(Math.random() * slides.length);
      let timer = null;
      let hovering = false;
      let keyboardFocus = false;
      let paused = false;
      let selected = false;
      let pageHidden = false;
      let heightFrame = null;
      let measuringFrame = null;
      const getSlideHeight = slide => {
        const viewportStyles = getComputedStyle(viewport);
        const borders = parseFloat(viewportStyles.borderTopWidth) + parseFloat(viewportStyles.borderBottomWidth);
        return Math.ceil(slide.offsetHeight + (viewportStyles.boxSizing === 'border-box' ? borders : 0));
      };
      const resizeViewport = (index = position, immediate = false) => {
        cancelAnimationFrame(heightFrame);
        heightFrame = requestAnimationFrame(() => {
          const slide = slides[index];
          if (!slide || !root.isConnected) return;
          const targetHeight = getSlideHeight(slide);
          if (!targetHeight) return;

          if (immediate || !viewport.style.height) {
            viewport.classList.add('is-measuring');
            viewport.style.height = `${targetHeight}px`;
            cancelAnimationFrame(measuringFrame);
            measuringFrame = requestAnimationFrame(() => viewport.classList.remove('is-measuring'));
            return;
          }

          const currentHeight = Math.round(viewport.getBoundingClientRect().height);
          if (Math.abs(currentHeight - targetHeight) > 1) {
            viewport.classList.add('is-resizing');
            viewport.style.height = `${targetHeight}px`;
          }
        });
      };
      const enabled = () => root.dataset.autoplay === 'true' && slides.length > 1 && !motion.matches;
      const stop = () => { clearTimeout(timer); timer = null; };
      const canPlay = () => root.isConnected && enabled() && !paused && !selected && !document.hidden && !pageHidden && !keyboardFocus && !(root.dataset.pauseHover === 'true' && hovering);
      const show = index => {
        position = (index + slides.length) % slides.length;
        slides.forEach((slide, i) => {
          const active = i === position;
          slide.classList.toggle('is-active', active);
          slide.setAttribute('aria-hidden', String(!active));
          slide.inert = !active;
        });
        dots.forEach((dot, i) => {
          dot.classList.toggle('is-active', i === position);
          dot.setAttribute('aria-current', String(i === position));
        });
        track.style.transform = `translate3d(-${position * 100}%, 0, 0)`;
        resizeViewport(position, !viewport.style.height || motion.matches);
      };
      const sync = () => {
        stop();
        const playing = canPlay();
        viewport.setAttribute('aria-live', playing ? 'off' : 'polite');
        if (toggle) {
          toggle.hidden = !enabled();
          toggle.textContent = paused ? 'Play reviews' : 'Pause reviews';
          toggle.setAttribute('aria-pressed', String(paused));
        }
        if (playing) timer = setTimeout(() => { show(position + 1); sync(); }, interval);
      };
      const navigate = index => { show(index); sync(); };
      on(root.querySelector('[data-review-prev]'), 'click', () => navigate(position - 1));
      on(root.querySelector('[data-review-next]'), 'click', () => navigate(position + 1));
      dots.forEach(dot => on(dot, 'click', () => navigate(Number(dot.dataset.reviewDot))));
      on(toggle, 'click', () => { paused = !paused; sync(); });
      on(root, 'pointerenter', event => {
        if (event.pointerType === 'mouse' && hoverMedia.matches) { hovering = true; if (root.dataset.pauseHover === 'true') sync(); }
      });
      on(root, 'pointerleave', () => { hovering = false; if (root.dataset.pauseHover === 'true') sync(); });
      on(root, 'pointerdown', () => { if (keyboardFocus) { keyboardFocus = false; sync(); } });
      on(root, 'focusin', event => {
        // Mouse/touch focus must not silently latch autoplay off.
        keyboardFocus = event.target.matches(':focus-visible');
        sync();
      });
      on(root, 'focusout', event => {
        if (!root.contains(event.relatedTarget)) { keyboardFocus = false; sync(); }
      });
      on(root, 'keydown', event => {
        if (event.key === 'Tab' && !keyboardFocus) { keyboardFocus = true; sync(); }
      });
      const restore = () => {
        hovering = hoverMedia.matches && root.matches(':hover');
        keyboardFocus = root.contains(document.activeElement) && document.activeElement.matches(':focus-visible');
        sync();
      };
      on(document, 'visibilitychange', restore);
      on(window, 'pagehide', () => { pageHidden = true; sync(); });
      on(window, 'pageshow', () => { pageHidden = false; restore(); });
      on(motion, 'change', sync);
      on(hoverMedia, 'change', restore);
      on(root, 'shopify:block:select', event => {
        const slide = event.target.closest('[data-review-slide]');
        const index = slides.indexOf(slide);
        if (index >= 0) { selected = true; show(index); sync(); }
      });
      on(root, 'shopify:block:deselect', () => { selected = false; sync(); });
      on(viewport, 'transitionend', event => {
        if (event.propertyName === 'height') viewport.classList.remove('is-resizing');
      });

      const sizeObserver = 'ResizeObserver' in window
        ? new ResizeObserver(entries => {
            if (entries.some(entry => entry.target === slides[position])) resizeViewport(position);
          })
        : null;
      slides.forEach(slide => sizeObserver?.observe(slide));

      if (document.fonts?.ready) {
        document.fonts.ready.then(() => {
          if (root.isConnected) resizeViewport(position);
        });
      }

      this.cleanup = () => {
        stop();
        cancelAnimationFrame(heightFrame);
        cancelAnimationFrame(measuringFrame);
        sizeObserver?.disconnect();
        controller.abort();
      };
      show(position);
      restore();
    }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["haircare-lipcare"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('ahvte-split-slider')) {
  customElements.define('ahvte-split-slider', class extends HTMLElement {
    connectedCallback() {
      this.cleanup?.();
      const track = this.querySelector('.ahvte-split__track');
      if (!track) return;
      const cards = [...track.children];
      const controls = this.querySelector('.ahvte-split__controls');
      const prev = controls.querySelector('[data-prev]');
      const next = controls.querySelector('[data-next]');
      const position = controls.querySelector('[data-position]');
      const controller = new AbortController();
      const options = {signal: controller.signal};
      let frame;
      const update = () => {
        const max = track.scrollWidth - track.clientWidth;
        controls.hidden = max < 3;
        prev.disabled = track.scrollLeft < 3;
        next.disabled = track.scrollLeft >= max - 3;
        const rect = track.getBoundingClientRect();
        const visible = cards.map((card, i) => ({rect: card.getBoundingClientRect(), i}))
          .filter(item => item.rect.right > rect.left + 4 && item.rect.left < rect.right - 4);
        if (visible.length) {
          const first = visible[0].i + 1;
          const last = visible[visible.length - 1].i + 1;
          const label = (first === last ? first : first + '–' + last) + ' / ' + cards.length;
          if (position.textContent !== label) position.textContent = label;
        }
      };
      const move = direction => {
        const step = cards[0].getBoundingClientRect().width + parseFloat(getComputedStyle(track).columnGap || 0);
        const count = Math.max(1, Math.floor((track.clientWidth + 18) / step));
        track.scrollBy({left:direction * step * count, behavior:matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth'});
      };
      prev.addEventListener('click', () => move(-1), options);
      next.addEventListener('click', () => move(1), options);
      track.addEventListener('keydown', event => {
        if (event.target !== track) return;
        if (event.key === 'ArrowLeft' || event.key === 'ArrowRight') {
          event.preventDefault(); move(event.key === 'ArrowLeft' ? -1 : 1);
        }
      }, options);
      track.addEventListener('scroll', () => {cancelAnimationFrame(frame);frame=requestAnimationFrame(update);}, {...options,passive:true});
      const observer = new ResizeObserver(update);
      observer.observe(track);
      this.cleanup = () => {controller.abort();observer.disconnect();cancelAnimationFrame(frame);};
      update();
    }
    disconnectedCallback() {this.cleanup?.();}
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-ahvte-journal"]) return;
  try {
    
if (!customElements.get('ahvte-journal-archive')) customElements.define('ahvte-journal-archive', class extends HTMLElement {
  connectedCallback() {
    if (this.cleanup) return;
    const lifetime = new AbortController(), signal = lifetime.signal;
    const select = this.querySelector('select'), grid = this.querySelector('[data-grid]'), status = this.querySelector('[data-status]'), cancel = this.querySelector('[data-cancel]');
    const nativePagination = this.querySelector('[data-native-pagination]'), enhancedPagination = this.querySelector('[data-enhanced-pagination]');
    const previous = this.querySelector('[data-page-prev]'), next = this.querySelector('[data-page-next]'), pageStatus = this.querySelector('[data-page-status]');
    const collator = new Intl.Collator(document.documentElement.lang || 'en', {sensitivity:'base', numeric:true});
    const total = Number(this.dataset.total), pages = Number(this.dataset.pages), nativePage = Number(this.dataset.currentPage);
    let all = null, sorted = [], page = 1, request = null, committedSort = 'newest';
    const cardData = element => ({element, id:element.dataset.articleId, title:element.dataset.title, published:Number(element.dataset.published)});
    const initial = [...grid.children].map(cardData);
    const interpolate = (message, values) => Object.entries(values).reduce((text,[key,value]) => text.replaceAll(`__${key}__`, String(value)), message);
    const render = (focus = false) => {
      const maximum = Math.max(1, Math.ceil(sorted.length / 24)); page = Math.min(maximum, Math.max(1, page));
      grid.replaceChildren(...sorted.slice((page - 1) * 24, page * 24).map(card => card.element));
      nativePagination.hidden = true; enhancedPagination.hidden = maximum <= 1;
      previous.disabled = page === 1; next.disabled = page === maximum;
      pageStatus.textContent = interpolate(this.dataset.pageLabel,{page, pages:maximum});
      status.textContent = interpolate(this.dataset.count,{count:sorted.length});
      if (focus) { grid.tabIndex = -1; grid.focus({preventScroll:true}); grid.scrollIntoView({behavior:'auto',block:'start'}); }
    };
    const applySort = () => {
      const tie = (a,b) => collator.compare(a.title,b.title) || a.id.localeCompare(b.id);
      sorted = [...all].sort((a,b) => select.value === 'oldest' ? a.published - b.published || tie(a,b) : select.value === 'az' ? collator.compare(a.title,b.title) || b.published - a.published || a.id.localeCompare(b.id) : select.value === 'za' ? collator.compare(b.title,a.title) || b.published - a.published || a.id.localeCompare(b.id) : b.published - a.published || tie(a,b));
      committedSort = select.value; page = 1; render();
    };
    const loadAll = async () => {
      if (all) { applySort(); return; }
      if (request) return;
      request = new AbortController(); const active = request;
      cancel.hidden = false; grid.setAttribute('aria-busy','true');
      try {
        if (!Number.isSafeInteger(total) || total > 25000 || !Number.isSafeInteger(pages) || pages < 1) throw new Error('Unsupported archive size');
        const records = new Map(initial.map(card => [card.id,card]));
        for (let p = 1; p <= pages; p++) {
          status.textContent = interpolate(this.dataset.loading,{page:p,pages});
          if (p === nativePage) continue;
          const url = new URL(location.href); url.hash = ''; url.searchParams.delete('sections');
          url.searchParams.set('section_id',this.dataset.sectionId); url.searchParams.set(this.dataset.pageParam || 'page',String(p));
          const timeout = setTimeout(() => active.abort(),20000);
          let response, html;
          try { response = await fetch(url.toString(),{signal:active.signal,credentials:'same-origin'}); if (!response.ok) throw new Error('Request failed'); html = await response.text(); } finally { clearTimeout(timeout); }
          if (active.signal.aborted) throw new Error('Cancelled');
          const doc = new DOMParser().parseFromString(html,'text/html');
          const archive = [...doc.querySelectorAll('ahvte-journal-archive')].find(item => item.dataset.sectionId === this.dataset.sectionId);
          if (!archive || Number(archive.dataset.total) !== total || Number(archive.dataset.pages) !== pages || Number(archive.dataset.currentPage) !== p) throw new Error('Archive changed or page unavailable');
          const cards = [...archive.querySelector('[data-grid]').children].map(cardData);
          if (!cards.length || cards.some(card => !card.id || !Number.isFinite(card.published))) throw new Error('Invalid articles');
          cards.forEach(card => records.set(card.id,card));
        }
        if (active.signal.aborted || records.size !== total) throw new Error('Incomplete archive');
        all = [...records.values()]; applySort();
      } catch (error) {
        if (this.isConnected) { select.value = committedSort; status.textContent = this.dataset.error; }
      } finally {
        request = null; cancel.hidden = true; grid.removeAttribute('aria-busy');
      }
    };
    if (total > 0) this.querySelector('.ahj__sort').hidden = false;
    select.addEventListener('change',loadAll,{signal});
    cancel.addEventListener('click',() => request?.abort(),{signal});
    previous.addEventListener('click',() => { page--; render(true); },{signal});
    next.addEventListener('click',() => { page++; render(true); },{signal});
    this.cleanup = () => { lifetime.abort(); request?.abort(); };
  }
  disconnectedCallback() { this.cleanup?.(); this.cleanup = null; }
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-cart-items"] && !Shopify.designMode) return;
  try {
    
/* AHVTE full cart page. Native Shopify cart requests; no add-to-cart interception. */
(() => {
  if (customElements.get('ahvte-cart-page-v2')) return;
  const normalize = value => String(value || '').trim().toLocaleLowerCase('en-US');

  class AhvteCartPage extends HTMLElement {
    static rankCandidates(catalog, cartProducts, ignoredTags = []) {
      const ignored = new Set(ignoredTags.map(normalize));
      const inCart = new Set(cartProducts.map(product => String(product.id)));
      const weights = new Map();
      for (const product of cartProducts) {
        const quantity = Math.max(0, Number(product.quantity) || 0);
        for (const tag of new Set((product.tags || []).map(normalize))) {
          if (tag && !ignored.has(tag)) weights.set(tag, (weights.get(tag) || 0) + quantity);
        }
      }
      const unique = new Map(catalog.map(product => [String(product.id), product]));
      return [...unique.values()].filter(product => product.available && !product.requires_selling_plan && !inCart.has(String(product.id)))
        .map(product => {
          const matches = [...new Set((product.tags || []).map(normalize))].filter(tag => weights.has(tag));
          return {product, score: matches.reduce((sum, tag) => sum + weights.get(tag), 0), matches: matches.length};
        })
        .filter(result => result.score > 0)
        .sort((a, b) => b.score - a.score || b.matches - a.matches || String(a.product.title).localeCompare(String(b.product.title)) || String(a.product.id).localeCompare(String(b.product.id)))
        .map(result => result.product);
    }

    connectedCallback() {
      if (this.lifecycle) return;
      this.lifecycle = new AbortController();
      this.busy = false;
      this.recommendationEpoch = 0;
      this.catalog = null;
      this.variantProducts = new Map();
      const signal = this.lifecycle.signal;
      this.addEventListener('click', event => this.handleClick(event), {signal});
      this.addEventListener('change', event => this.handleChange(event), {signal});
      this.addEventListener('submit', event => {
        if (!event.target.matches('[data-cart-form]')) return;
        if (this.busy || this.stale) { event.preventDefault(); return; }
        if (event.submitter?.name === 'checkout') return;
        event.preventDefault();
        if (document.activeElement?.matches('[data-quantity]')) this.updateInput(document.activeElement);
      }, {signal});
      document.addEventListener('ahvte:bag-changed', () => this.externalRefresh(), {signal});
      window.addEventListener('pageshow', event => { if (event.persisted) this.externalRefresh(); }, {signal});
      // Refresh/Dawn's pub/sub system, when present, covers their other cart controls.
      if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
        this.unsubscribeTheme = subscribe(PUB_SUB_EVENTS.cartUpdate, () => this.externalRefresh());
      }
      this.readState();
      this.shipping();
      void this.recommend();
    }

    disconnectedCallback() {
      this.lifecycle?.abort(); this.lifecycle = null;
      this.unsubscribeTheme?.(); this.unsubscribeTheme = null;
      this.recommendationEpoch++;
    }
    q(selector) { return this.querySelector(selector); }
    readState() {
      this.state = JSON.parse(this.q('[data-cart-state]').textContent);
      try { this.thresholds = JSON.parse(this.state.local_thresholds || '{}'); } catch { this.thresholds = {}; }
      if (!this.destination) this.destination = this.dataset.country === 'US' ? 'US' : 'INT';
      this.q('[data-destination]').value = this.destination;
    }
    money(cents) {
      return new Intl.NumberFormat(document.documentElement.lang || 'en-US', {style: 'currency', currency: this.state.cart.currency, currencyDisplay: 'code'}).format(Number(cents) / 100);
    }
    shipping() {
      const cart = this.state.cart;
      const usd = this.destination === 'US' ? 49 : 69;
      const threshold = cart.currency === 'USD' ? usd : Number(this.thresholds?.[cart.currency]?.[this.destination]);
      const valid = Number.isFinite(threshold) && threshold > 0;
      const progress = this.q('[data-progress]');
      progress.hidden = !valid;
      if (!valid) {
        this.q('[data-shipping-message]').textContent = `Free shipping from $${usd} USD. Eligibility is confirmed at checkout in your selected currency.`;
        return;
      }
      const target = Math.round(threshold * 100);
      const remaining = Math.max(0, target - cart.total_price);
      const percent = Math.min(100, Math.max(0, cart.total_price / target * 100));
      this.q('[data-shipping-message]').textContent = remaining ? `${this.money(remaining)} away from free shipping.` : 'You’ve reached the free-shipping threshold. Good taste pays off.';
      progress.setAttribute('aria-valuenow', String(Math.round(percent)));
      progress.setAttribute('aria-valuetext', remaining ? `${this.money(remaining)} remaining` : 'Free-shipping threshold reached');
      this.q('[data-progress-fill]').style.width = `${percent}%`;
    }

    async request(url, options = {}) {
      const controller = new AbortController();
      const lifecycle = this.lifecycle?.signal;
      if (!lifecycle || lifecycle.aborted) throw new Error('Cart page is no longer active.');
      const abort = () => controller.abort();
      lifecycle.addEventListener('abort', abort, {once: true});
      const timer = setTimeout(abort, 15000);
      try {
        return await fetch(url, {credentials: 'same-origin', cache: 'no-store', ...options, signal: controller.signal});
      } finally { clearTimeout(timer); lifecycle.removeEventListener('abort', abort); }
    }
    async cartRequest(endpoint, payload) {
      const response = await this.request(this.dataset.root + endpoint, {method: 'POST', headers: {'Content-Type': 'application/json', Accept: 'application/json'}, body: JSON.stringify(payload)});
      const data = await response.json();
      if (!response.ok || data.status >= 400) throw new Error(typeof data.description === 'string' ? data.description : 'We couldn’t update your cart. Please try again.');
      return data;
    }
    setBusy(value) {
      this.busy = value;
      this.q('[data-cart-content]').setAttribute('aria-busy', String(value));
      this.querySelectorAll('[data-step], [data-quantity], [data-add], [data-recommendation-variant], [data-checkout], [data-retry]').forEach(node => { node.disabled = value; });
      const checkout = this.q('[data-checkout]');
      if (checkout) checkout.disabled = value || Boolean(this.stale);
      const express = this.q('[data-express-checkout]');
      if (express) {
        const locked = value || Boolean(this.stale);
        express.inert = locked;
        express.setAttribute('aria-disabled', String(locked));
        express.setAttribute('aria-busy', String(value));
      }
      this.querySelectorAll('[data-remove]').forEach(node => node.setAttribute('aria-disabled', String(value)));
    }
    showError(message) {
      this.q('[data-error]').textContent = message;
      this.q('[data-error]').hidden = !message;
      this.q('[data-retry]').hidden = !message;
    }
    async refreshContent() {
      const url = new URL(location.href);
      url.pathname = this.dataset.cartUrl;
      url.searchParams.set('section_id', this.dataset.sectionId);
      const response = await this.request(url.href);
      if (!response.ok) throw new Error('Your cart changed, but we couldn’t refresh the page. Please refresh your cart before checking out.');
      const html = new DOMParser().parseFromString(await response.text(), 'text/html');
      const content = html.querySelector('ahvte-cart-page-v2 [data-cart-content]');
      if (!content || !content.querySelector('[data-cart-state]')) throw new Error('We couldn’t refresh your cart. Please reload the page.');
      this.q('[data-cart-content]').replaceChildren(...content.childNodes);
      this.readState(); this.stale = false; this.shipping(); this.syncHeader();
      this.q('[data-status]').textContent = `${this.state.cart.item_count} items in your cart. Estimated total ${this.money(this.state.cart.total_price)}.`;
      this.setBusy(this.busy);
      void this.recommend();
    }
    syncHeader() {
      const count = this.state.cart.item_count;
      document.querySelectorAll('[data-ahvte-bag-open]').forEach(trigger => {
        trigger.setAttribute('aria-label', `Cart, ${count} items`);
        let badge = trigger.querySelector('.ahvte-header__cart-count');
        if (!badge) { badge = document.createElement('span'); badge.className = 'ahvte-header__cart-count'; badge.setAttribute('aria-hidden', 'true'); trigger.append(badge); }
        badge.textContent = count; badge.hidden = !count; badge.style.display = count ? '' : 'none';
      });
      document.dispatchEvent(new CustomEvent('ahvte:cart-updated'));
    }
    async externalRefresh() {
      if (this.busy) { this.pendingRefresh = true; return; }
      this.setBusy(true);
      try { await this.refreshContent(); this.showError(''); }
      catch (error) { if (this.isConnected) { this.stale = true; this.showError(error.message); } }
      finally { if (this.isConnected) this.finish(); }
    }
    finish() {
      this.setBusy(false);
      if (this.pendingRefresh) { this.pendingRefresh = false; queueMicrotask(() => { if (this.isConnected) void this.externalRefresh(); }); }
    }
    async mutate(endpoint, payload, focusKey, action) {
      if (this.busy) return;
      if (this.stale) { this.showError('Refresh your cart before making another change.'); return; }
      this.setBusy(true); this.showError('');
      // Invalidate any in-flight recommendation rendering immediately.
      this.recommendationEpoch++;
      let committed = false;
      try {
        await this.cartRequest(endpoint, payload);
        committed = true;
        await this.refreshContent();
        this.setBusy(false);
        const line = [...this.querySelectorAll('[data-line-key]')].find(node => node.dataset.lineKey === focusKey);
        const focusTarget = line?.querySelector(action === 'input' ? '[data-quantity]' : `[data-step="${action}"]`);
        (focusTarget || this.q('h1')).focus({preventScroll: true});
      } catch (error) {
        // Never retry an add automatically: a lost response may still mean it succeeded.
        let reconciled = false;
        this.stale = true;
        try { await this.refreshContent(); reconciled = true; } catch {}
        if (this.isConnected) this.showError(committed && !reconciled ? 'Your change was saved, but the cart could not refresh. Reload the page before adding again.' : error.message);
      } finally { if (this.isConnected) this.finish(); }
    }
    handleClick(event) {
      const remove = event.target.closest('[data-remove]');
      if (remove) { event.preventDefault(); if (!this.busy) void this.mutate('cart/change.js', {id: remove.dataset.key, quantity: 0}, remove.dataset.key, 'remove'); return; }
      const step = event.target.closest('[data-step]');
      if (step) {
        if (this.busy) return;
        const input = step.closest('[data-line-key]').querySelector('[data-quantity]');
        const increment = Number(input.step) || 1, minimum = Number(input.min) || 1;
        let quantity = Number(input.value) + Number(step.dataset.step) * increment;
        if (quantity < minimum) quantity = 0;
        if (input.max && quantity > Number(input.max)) { this.showError(`The maximum quantity for this item is ${input.max}.`); return; }
        void this.mutate('cart/change.js', {id: step.dataset.key, quantity}, step.dataset.key, step.dataset.step);
        return;
      }
      if (event.target.closest('[data-retry]')) { void this.externalRefresh(); return; }
      const add = event.target.closest('[data-add]');
      if (add && !this.busy) {
        void this.mutate('cart/add.js', {items: [{id: Number(add.dataset.variantId), quantity: Number(add.dataset.minimum) || 1}]}, null, 'add');
      }
    }
    handleChange(event) {
      if (event.target.matches('[data-destination]')) { this.destination = event.target.value; this.shipping(); }
      if (event.target.matches('[data-quantity]')) this.updateInput(event.target);
      if (event.target.matches('[data-recommendation-variant]')) {
        const select = event.target, card = select.closest('[data-card]');
        const variant = this.variantProducts.get(card.dataset.productId)?.variants.find(v => String(v.id) === select.value);
        if (variant) this.updateCardVariant(card, variant);
      }
    }
    updateInput(input) {
      if (this.busy) return;
      const quantity = Number(input.value);
      const minimum = Number(input.min) || 1, step = Number(input.step) || 1;
      if (!input.value.trim() || !Number.isInteger(quantity) || quantity < 0 || (quantity !== 0 && (quantity < minimum || (quantity - minimum) % step !== 0)) || (input.max && quantity > Number(input.max))) {
        this.showError('Please enter a valid quantity for this item.');
        input.value = this.state.cart.items.find(item => item.key === input.dataset.key)?.quantity || minimum;
        return;
      }
      void this.mutate('cart/change.js', {id: input.dataset.key, quantity}, input.dataset.key, 'input');
    }

    async loadCatalog() {
      if (this.catalog) return this.catalog;
      if (this.catalogPromise) return this.catalogPromise;
      this.catalogPromise = (async () => {
        const initial = new URL(this.dataset.catalogUrl, location.origin);
        const preview = new URL(location.href).searchParams.get('preview_theme_id');
        if (preview) initial.searchParams.set('preview_theme_id', preview);
        initial.searchParams.set('section_id', 'ahvte-cart-page');
        let next = initial.href;
        const seen = new Set(), products = new Map();
        while (next) {
          const url = new URL(next, location.origin);
          if (url.origin !== location.origin) throw new Error('Invalid catalog destination.');
          url.searchParams.set('section_id', 'ahvte-cart-page');
          if (preview) url.searchParams.set('preview_theme_id', preview);
          if (seen.has(url.href)) throw new Error('Catalog pagination repeated a page.');
          seen.add(url.href);
          const response = await this.request(url.href);
          if (!response.ok) throw new Error('Recommendations are temporarily unavailable.');
          const document = new DOMParser().parseFromString(await response.text(), 'text/html');
          const script = document.querySelector('[data-ahvte-catalog]');
          if (!script) throw new Error('Recommendations could not load. Please refresh the page.');
          const data = JSON.parse(script.textContent);
          data.products.forEach(product => products.set(String(product.id), product));
          next = data.next;
        }
        this.catalog = [...products.values()];
        return this.catalog;
      })();
      try { return await this.catalogPromise; }
      finally { this.catalogPromise = null; }
    }
    async productDetails(product) {
      const response = await this.request(this.dataset.root + 'products/' + encodeURIComponent(product.handle) + '.js');
      if (!response.ok) return null;
      const details = await response.json();
      if (!details.available || details.requires_selling_plan) return null;
      return {...details, url: product.url};
    }
    async recommend() {
      const epoch = ++this.recommendationEpoch;
      const section = this.q('[data-recommendations]');
      // Never leave products already in the refreshed cart visible as suggestions.
      const inCart = new Set(this.state.products.map(product => String(product.id)));
      this.querySelectorAll('[data-card]').forEach(card => { if (inCart.has(card.dataset.productId)) card.remove(); });
      if (!this.state.cart.item_count) { section.hidden = true; return; }
      try {
        const catalog = await this.loadCatalog();
        if (!this.isConnected || epoch !== this.recommendationEpoch) return;
        const ranked = AhvteCartPage.rankCandidates(catalog, this.state.products, (this.dataset.ignoredTags || '').split(','));
        const limit = Math.min(8, Math.max(2, Number(this.dataset.recommendationLimit) || 4));
        const selected = [];
        for (let index = 0; index < ranked.length && selected.length < limit; index += 3) {
          const details = await Promise.all(ranked.slice(index, index + 3).map(product => this.productDetails(product).catch(() => null)));
          if (!this.isConnected || epoch !== this.recommendationEpoch) return;
          selected.push(...details.filter(product => product && product.variants.some(variant => variant.available)));
        }
        const cards = selected.slice(0, limit).map(product => this.buildCard(product));
        this.q('[data-recommendation-grid]').replaceChildren(...cards);
        section.hidden = cards.length === 0;
        this.setBusy(this.busy);
      } catch (error) {
        if (this.isConnected && epoch === this.recommendationEpoch) {
          section.hidden = true;
          // Recommendation failure must never prevent checkout or cart updates.
          console.warn('[AHVTE recommendations]', error.message);
        }
      }
    }
    element(tag, className, text) {
      const node = document.createElement(tag);
      if (className) node.className = className;
      if (text !== undefined) node.textContent = text;
      return node;
    }
    safeURL(value) {
      try { const url = new URL(value, location.origin); return ['http:', 'https:'].includes(url.protocol) ? url.href : '#'; }
      catch { return '#'; }
    }
    buildCard(product) {
      this.variantProducts.set(String(product.id), product);
      const card = this.element('article', 'acp__card'); card.dataset.card = ''; card.dataset.productId = product.id;
      const imageLink = this.element('a', 'acp__card-image'); imageLink.href = this.safeURL(product.url); imageLink.tabIndex = -1; imageLink.setAttribute('aria-hidden', 'true');
      const featuredImage = typeof product.featured_image === 'string' ? product.featured_image : product.featured_image?.src;
      if (featuredImage) { const image = this.element('img'); image.src = this.safeURL(featuredImage); image.alt = ''; image.width = 320; image.height = 320; image.loading = 'lazy'; imageLink.append(image); }
      const heading = this.element('h3'); const link = this.element('a', '', product.title); link.href = this.safeURL(product.url); heading.append(link);
      const price = this.element('p', 'acp__card-price'); price.dataset.cardPrice = '';
      const controls = this.element('div', 'acp__card-controls');
      const available = product.variants.filter(variant => variant.available);
      if (product.variants.length >= 250) {
        // The Product Ajax API caps variants at 250; route larger products to their full option picker.
        const options = this.element('a', 'acp__button', 'Choose options'); options.href = this.safeURL(product.url); controls.append(options);
      } else {
        if (product.variants.length > 1) {
          const select = this.element('select'); select.dataset.recommendationVariant = ''; select.setAttribute('aria-label', `Choose an option for ${product.title}`);
          available.forEach(variant => { const option = this.element('option', '', variant.title); option.value = variant.id; select.append(option); });
          controls.append(select);
        }
        const add = this.element('button', 'acp__button', 'Add to cart'); add.type = 'button'; add.dataset.add = ''; add.setAttribute('aria-label', `Add ${product.title} to cart`); controls.append(add);
      }
      card.append(imageLink, heading, price, controls);
      this.updateCardVariant(card, available[0]);
      return card;
    }
    updateCardVariant(card, variant) {
      card.querySelector('[data-card-price]').textContent = this.money(variant.price);
      const add = card.querySelector('[data-add]');
      if (add) {
        add.dataset.variantId = variant.id;
        add.dataset.minimum = variant.quantity_rule?.min || 1;
        add.textContent = Number(add.dataset.minimum) > 1 ? `Add ${add.dataset.minimum} to cart` : 'Add to cart';
      }
      const image = card.querySelector('img');
      if (image && variant.featured_image?.src) image.src = this.safeURL(variant.featured_image.src);
    }
  }
  customElements.define('ahvte-cart-page-v2', AhvteCartPage);
})();


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["related-products"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const SELECTOR = '[data-cab-section]';
    function enhanceRecommendations(section, cleanup) {
      if (section.dataset.recommendationsLoaded === 'true' || !section.dataset.recommendationsUrl) return;
      section.dataset.recommendationsLoaded = 'true';
      let interacted = false;
      const markInteracted = () => { interacted = true; };
      const events = ['pointerdown', 'keydown', 'focusin', 'wheel', 'touchstart'];
      events.forEach((event) => section.addEventListener(event, markInteracted, { once: true, passive: true }));
      fetch(section.dataset.recommendationsUrl, {
        credentials: 'same-origin',
        headers: { Accept: 'text/html' }
      })
        .then((response) => {
          if (!response.ok) throw new Error('Recommendations unavailable');
          return response.text();
        })
        .then((html) => {
          if (interacted || !section.isConnected || section.contains(document.activeElement)) return;
          const documentCopy = new DOMParser().parseFromString(html, 'text/html');
          const replacement = documentCopy.querySelector(SELECTOR);
          if (!replacement || !replacement.querySelector('[data-cab-card]')) return;
          replacement.dataset.recommendationsLoaded = 'true';
          replacement.hidden = false;
          cleanup();
          section.replaceWith(replacement);
          initialise(replacement);
        })
        .catch(() => {})
        .finally(() => events.forEach((event) => section.removeEventListener(event, markInteracted)));
    }

    function initialise(section) {
      if (!section || section.dataset.initialised === 'true') return;

      const track = section.querySelector('[data-cab-track]');
      const viewport = section.querySelector('[data-cab-viewport]');
      const previous = section.querySelector('[data-cab-previous]');
      const next = section.querySelector('[data-cab-next]');
      const progress = section.querySelector('[data-cab-progress]');
      const status = section.querySelector('[data-cab-status]');
      const candidates = [...section.querySelectorAll('[data-cab-card]')];
      if (!track || !viewport) return;
      if (candidates.length === 0) {
        section.hidden = true;
        section.dataset.initialised = 'true';
        enhanceRecommendations(section, () => {});
        return;
      }
      section.dataset.initialised = 'true';

      const cardStep = () => {
        const card = track.querySelector('[data-cab-card]');
        if (!card) return viewport.clientWidth;
        const gap = parseFloat(getComputedStyle(track).gap) || 0;
        return card.getBoundingClientRect().width + gap;
      };

      const updateControls = () => {
        const maxScroll = Math.max(0, viewport.scrollWidth - viewport.clientWidth);
        const position = Math.min(maxScroll, Math.max(0, viewport.scrollLeft));
        previous.disabled = position <= 2;
        next.disabled = position >= maxScroll - 2;
        progress.style.transform = `scaleX(${maxScroll ? position / maxScroll : 1})`;
      };

      previous.addEventListener('click', () => viewport.scrollBy({ left: -cardStep(), behavior: 'smooth' }));
      next.addEventListener('click', () => viewport.scrollBy({ left: cardStep(), behavior: 'smooth' }));
      viewport.addEventListener('scroll', updateControls, { passive: true });
      window.addEventListener('resize', updateControls, { passive: true });

      let dragging = false;
      let originX = 0;
      let originScroll = 0;
      viewport.addEventListener('pointerdown', (event) => {
        if (event.pointerType !== 'mouse' || event.button !== 0 || event.target.closest('button, a')) return;
        dragging = true;
        originX = event.clientX;
        originScroll = viewport.scrollLeft;
        viewport.classList.add('is-dragging');
        viewport.setPointerCapture(event.pointerId);
      });
      viewport.addEventListener('pointermove', (event) => {
        if (!dragging) return;
        viewport.scrollLeft = originScroll - (event.clientX - originX);
      });
      const finishDrag = () => {
        dragging = false;
        viewport.classList.remove('is-dragging');
      };
      viewport.addEventListener('pointerup', finishDrag);
      viewport.addEventListener('pointercancel', finishDrag);

      section.querySelectorAll('[data-cab-add]').forEach((button) => {
        button.addEventListener('click', async () => {
          if (button.disabled || button.classList.contains('is-loading')) return;
          const originalLabel = button.querySelector('[data-cab-label]').textContent;
          button.classList.add('is-loading');
          button.setAttribute('aria-busy', 'true');

          try {
            const cartUI = document.querySelector('cart-drawer, cart-notification');
            const payload = { items: [{ id: Number(button.dataset.variantId), quantity: 1 }] };
            if (cartUI?.getSectionsToRender) {
              payload.sections = cartUI.getSectionsToRender().map((item) => item.id);
              payload.sections_url = window.location.pathname;
            }

            const response = await fetch(`${window.Shopify?.routes?.root || '/'}cart/add.js`, {
              method: 'POST',
              headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
              body: JSON.stringify(payload)
            });
            const result = await response.json();
            if (!response.ok) throw new Error(result.description || 'Could not add this item.');

            if (cartUI?.renderContents) cartUI.renderContents(result);
            document.dispatchEvent(new CustomEvent('cart:updated', { detail: { cart: result, source: 'customers-also-bought' } }));
            button.querySelector('[data-cab-label]').textContent = 'Added';
            status.textContent = 'Item added to cart.';
            window.setTimeout(() => { button.querySelector('[data-cab-label]').textContent = originalLabel; }, 1600);
          } catch (error) {
            status.textContent = error.message;
            button.querySelector('[data-cab-label]').textContent = 'Try again';
            window.setTimeout(() => { button.querySelector('[data-cab-label]').textContent = originalLabel; }, 2000);
          } finally {
            button.classList.remove('is-loading');
            button.removeAttribute('aria-busy');
          }
        });
      });

      updateControls();
      enhanceRecommendations(section, () => window.removeEventListener('resize', updateControls));
    }

    const initialiseAll = (root = document) => root.querySelectorAll(SELECTOR).forEach(initialise);
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', () => initialiseAll());
    } else {
      initialiseAll();
    }
    document.addEventListener('shopify:section:load', (event) => initialiseAll(event.target));
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["slideshow"] && !Shopify.designMode) return;
  try {
    
(() => {
  if (customElements.get('ahvte-cart-picks-rendered')) return;
  customElements.define('ahvte-cart-picks-rendered', class extends HTMLElement {
    connectedCallback() {
      if(this.life) return;
      this.life=new AbortController(); const signal=this.life.signal;
      this.addEventListener('submit', e=>{if(e.target.matches('[data-add-form]')){e.preventDefault();e.stopPropagation();void this.add(e.target);}}, {signal});
      this.addEventListener('change', e=>{
        if(!e.target.matches('[data-variant]'))return;
        const option=e.target.selectedOptions[0], form=e.target.form;
        form.closest('[data-card]').querySelector('[data-price]').textContent=option.dataset.price;
        form.elements.quantity.value=option.dataset.min||1;
        form.querySelector('[data-add]').textContent=Number(option.dataset.min)>1?`Add ${option.dataset.min} to cart`:'Add to cart';
      },{signal});
      this.addEventListener('click',e=>{if(e.target.closest('[data-retry]'))void this.refresh();},{signal});
      const external=e=>{if(e.detail?.source!==this)void this.refresh();};
      document.addEventListener('ahvte:cart-updated',external,{signal});
      document.addEventListener('ahvte:bag-changed',external,{signal});
      window.addEventListener('pageshow',e=>{if(e.persisted)void this.refresh();},{signal});
      if(typeof subscribe==='function'&&typeof PUB_SUB_EVENTS!=='undefined')this.unsubscribe=subscribe(PUB_SUB_EVENTS.cartUpdate,()=>void this.refresh());
    }
    disconnectedCallback(){this.life?.abort();this.life=null;this.unsubscribe?.();}
    q(s){return this.querySelector(s);}
    lock(value){this.busy=value;this.q('[data-picks-content]').setAttribute('aria-busy',String(value));this.querySelectorAll('[data-add], [data-variant], [data-retry]').forEach(e=>e.disabled=value);}
    error(text){this.q('[data-error]').textContent=text;this.q('[data-error]').hidden=!text;this.q('[data-retry]').hidden=!text;}
    async request(url,options={}){
      const response=await fetch(url,{credentials:'same-origin',cache:'no-store',...options,signal:this.life.signal});
      return response;
    }
    async render(){
      const url=new URL(location.href);url.pathname=this.dataset.cartUrl;
      url.searchParams.set('section_id',this.dataset.sectionId);
      const response=await this.request(url.href);
      if(!response.ok)throw Error('Could not refresh recommendations. Please try again.');
      const doc=new DOMParser().parseFromString(await response.text(),'text/html');
      const content=doc.querySelector('ahvte-cart-picks-rendered [data-picks-content]');
      if(!content)throw Error('Could not load the updated section. Please refresh the page.');
      this.q('[data-picks-content]').replaceWith(content);this.lock(this.busy);
      const count=Number(content.dataset.count)||0;
      document.querySelectorAll('[data-ahvte-bag-open]').forEach(trigger=>{
        trigger.setAttribute('aria-label',`Cart, ${count} items`);
        let badge=trigger.querySelector('.ahvte-header__cart-count');
        if(!badge){badge=document.createElement('span');badge.className='ahvte-header__cart-count';badge.setAttribute('aria-hidden','true');trigger.append(badge);}
        badge.textContent=count;badge.hidden=!count;badge.style.display=count?'':'none';
      });
    }
    finish(){this.lock(false);if(this.pending){this.pending=false;queueMicrotask(()=>{if(this.isConnected)void this.refresh();});}}
    async refresh(){
      if(this.busy){this.pending=true;return;}
      this.lock(true);
      try{await this.render();this.error('');}catch(e){if(this.isConnected)this.error(e.message);}finally{if(this.isConnected)this.finish();}
    }
    async add(form){
      if(this.busy)return;
      const data=new FormData(form);this.lock(true);this.error('');
      let saved=false;
      try{
        const response=await this.request(this.dataset.root+'cart/add.js',{method:'POST',body:data,headers:{Accept:'application/json'}});
        const result=await response.json();
        if(!response.ok||result.status>=400)throw Error(result.description||'This item could not be added. Please try again.');
        saved=true;
        this.q('[data-feedback]').textContent='Added to your cart.';this.q('[data-feedback]').hidden=false;
        await this.render();this.q('h2').focus({preventScroll:true});
      }catch(e){
        // An uncertain response is reconciled, never automatically re-posted.
        try{await this.render();}catch{}
        if(this.isConnected)this.error(saved?'Added to your cart. Refresh the page for the latest picks.':e.message);
      }finally{
        if(this.isConnected){
          this.finish();
          document.dispatchEvent(new CustomEvent('ahvte:cart-updated',{detail:{source:this}}));
          document.dispatchEvent(new CustomEvent('ahvte:bag-changed',{detail:{source:this}}));
        }
      }
    }
  });
})();


  } catch(e) { console.error(e); }
})();
})();
